import React, { useState } from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import { SectionStyle } from '../index.styled'
import { EditPanIcon } from '../../../components/icons'
import EditableText from '../components/EditableText'

const Container = styled.section`
  ${SectionStyle}
  position: relative;

  & > button {
    position: absolute;
    right: 200px;
    top: 110px;
  }
`
const NOTES_FIELDS = {
  INTRODUCTION_NOTE: 'introduction_note'
}

export default function IntroductionSection(props) {
  const [editing, setEditing] = useState(false)
  const { notes, handleCommendSave } = props
  const note = notes.find((n) => n.pillar === NOTES_FIELDS.INTRODUCTION_NOTE)
  return (
    <Container>
      <h1 className="ar-section-title">Executive Summary</h1>
      {!editing && props.editabled && (
        <Button type="primary" ghost onClick={() => setEditing(!editing)}>
          <EditPanIcon />
          EDIT
        </Button>
      )}
      <EditableText
        value={(note && note.memo) || ''}
        placeholder={'Please type here.'}
        editing={editing}
        setEditing={setEditing}
        fontStyle={{
          fontSize: '15px',
          fontColor: 'rgba(82, 96, 108, 1)'
        }}
        onSave={(text) => {
          handleCommendSave(text, NOTES_FIELDS.INTRODUCTION_NOTE)
        }}
      />
    </Container>
  )
}
